module.exports = "https://cdn.littlereply.com/tt/resource/image_next_arrow_gray@3x.7fb0f2be827f56e248ec604716d88205.png";